import React from 'react';

import i18n from 'util/i18n';

import { Summary, DateSummary } from 'components/Summary';

import { PSYCHOLOGICAL, PSYCHOLOGICAL_COMPETENCE } from 'config/formSections/psychological';
import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';

import { EmptyListInstance } from 'forms/shared/models';
import Branch from 'components/Form/Branch';
import Accordion from 'components/Form/Accordion';
import Comments from 'components/Form/Comments';
import { isPVQForm } from 'helpers/form';
import { PVQ_A_B_D } from 'constants/formTypes';
import Order from '../Order';

const sectionConfig = {
  key: PSYCHOLOGICAL_COMPETENCE.key,
  section: PSYCHOLOGICAL.name,
  store: PSYCHOLOGICAL.store,
  subsection: PSYCHOLOGICAL_COMPETENCE.name,
  storeKey: PSYCHOLOGICAL_COMPETENCE.storeKey,
};

export class Competence extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.updateIsIncompentent = this.updateIsIncompentent.bind(this);
    this.updateList = this.updateList.bind(this);
    this.summary = this.summary.bind(this);
    this.updateComments = this.updateComments.bind(this);
    this.updateSummaryComments = this.updateSummaryComments.bind(this);
  }

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      List: this.props.List,
      IsIncompetent: this.props.IsIncompetent,
      Comments: this.props.Comments,
      SummaryComments: this.props.SummaryComments,
      ...queue,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateComments(values) {
    this.update({
      Comments: values,
    });
  }

  updateSummaryComments(values) {
    this.update({
      SummaryComments: values,
    });
  }

  updateIsIncompentent = (values) => {
    this.update({
      IsIncompetent: values,
      List: values.value === 'Yes' ? this.props.List : [],
      SummaryComments: values.value === 'Yes' ? this.props.SummaryComments : {},
    });
  };

  summary = (item, index) => {
    const o = (item || {}).Item || {};
    const occurred = DateSummary(o.Occurred || {});
    const courtName = (o.CourtName || {}).value || '';

    return Summary({
      type: i18n.t('psychological.competence.collection.itemType'),
      index,
      left: courtName,
      right: occurred,
      placeholder: i18n.t('psychological.competence.collection.summaryCourtName'),
    });
  };

  render() {
    const { errors, formType } = this.props;
    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);

    const sectionPrefix = (this.props.formType === PVQ_A_B_D) ? 'Part D:' : 'Section 28:';
    const isPvq = isPVQForm(formType);
    return isPvq ? (
      <div
        className="section-content competence"
        data-section={PSYCHOLOGICAL.key}
        data-subsection={PSYCHOLOGICAL_COMPETENCE.key}
      >
        <h1 className="section-header">{`${sectionPrefix} ${i18n.t('psychological.pvq.destination.competence')}`}</h1>
        <Branch
          name="is_incompetent"
          label={i18n.t('psychological.pvq.heading.competence')}
          labelSize="h4"
          {...this.props.IsIncompetent}
          warning
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          required={this.props.required}
          onUpdate={this.updateIsIncompentent} // eslint-disable-line @typescript-eslint/unbound-method
          scrollIntoView={this.props.scrollIntoView}
          attribute="IsIncompetent"
        />

        {
          this.props.IsIncompetent.value === 'Yes'
          && (
            <Accordion
              defaultState={this.props.defaultState}
              {...this.props.List}
              scrollToBottom={this.props.scrollToBottom}
              summary={this.summary} // eslint-disable-line @typescript-eslint/unbound-method
              onUpdate={this.updateList} // eslint-disable-line @typescript-eslint/unbound-method
              onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
              errors={accordionErrors}
              description={i18n.t('psychological.pvq.competence.collection.description')}
              appendTitle={i18n.t('psychological.pvq.competence.collection.appendTitle')}
              appendLabel={i18n.t('psychological.pvq.competence.collection.appendLabel')}
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              attribute="List"
            >
              <Order
                name="Item"
                prefix="competence"
                addressBooks={this.props.addressBooks}
                dispatch={this.props.dispatch}
                required={this.props.required}
                scrollIntoView={this.props.scrollIntoView}
                bind
                attribute="List"
                formType={this.props.formType}
              />
            </Accordion>
          )
        }
      </div>
    ) : (
      <div
        className="section-content competence"
        data-section={PSYCHOLOGICAL.key}
        data-subsection={PSYCHOLOGICAL_COMPETENCE.key}
      >
        <h1 className="section-header">{i18n.t('psychological.destination.competence')}</h1>
        <Branch
          name="is_incompetent"
          label={i18n.t('psychological.heading.competence')}
          labelSize="h4"
          {...this.props.IsIncompetent}
          warning
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          required={this.props.required}
          onUpdate={this.updateIsIncompentent} // eslint-disable-line @typescript-eslint/unbound-method
          scrollIntoView={this.props.scrollIntoView}
          attribute="IsIncompetent"
        />
        <Comments
          title={i18n.t('psychological.competence.comments')}
          name="Comments"
          attribute="Comments"
          className="optional-comments"
          {...this.props.Comments}
          onUpdate={this.updateComments}
          onError={this.props.onError}
          required={false}
        />

        {
          this.props.IsIncompetent.value === 'Yes'
          && (
            <>
              <Accordion
                defaultState={this.props.defaultState}
                {...this.props.List}
                scrollToBottom={this.props.scrollToBottom}
                summary={this.summary} // eslint-disable-line @typescript-eslint/unbound-method
                onUpdate={this.updateList} // eslint-disable-line @typescript-eslint/unbound-method
                onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
                errors={accordionErrors}
                description={i18n.t('psychological.competence.collection.description')}
                appendTitle={i18n.t('psychological.competence.collection.appendTitle')}
                appendLabel={i18n.t('psychological.competence.collection.appendLabel')}
                required={this.props.required}
                scrollIntoView={this.props.scrollIntoView}
                attribute="List"
              >
                <Order
                  name="Item"
                  prefix="competence"
                  addressBooks={this.props.addressBooks}
                  dispatch={this.props.dispatch}
                  required={this.props.required}
                  scrollIntoView={this.props.scrollIntoView}
                  bind
                  attribute="List"
                />
              </Accordion>
              <Comments
                title={i18n.t('psychological.competence.summaryComments')}
                name="SummaryComments"
                attribute="SummaryComments"
                className="optional-comments"
                {...this.props.SummaryComments}
                onUpdate={this.updateSummaryComments}
                onError={this.props.onError}
                required={false}
              />
            </>
          )
        }
      </div>
    );
  }
}

Competence.defaultProps = {
  IsIncompetent: {},
  List: EmptyListInstance,
  Comments: {},
  SummaryComments: {},
  defaultState: true,
  onUpdate: () => { },
  onError: (value, arr) => arr,
  addressBooks: {},
  dispatch: () => { },
  scrollToBottom: '.bottom-btns',
  errors: [],
  formType: '',
};

export default connectSubsection(Competence, sectionConfig);
